import React from 'react';
import ComponentsShowcase from '../Views/ComponentsShowcase';

/**
 * ComponentsShowcaseView - Route component for the Components Showcase
 * Simple wrapper that renders the ComponentsShowcase component
 */
const ComponentsShowcaseView = () => {
  return <ComponentsShowcase />;
};

export default ComponentsShowcaseView;
